import { useState, useRef, useLayoutEffect, useEffect } from "react";

import { useLocation } from "react-router-dom";

import useMediaQuery from "Hooks/useMediaQuery";

const useIsNarrowContainer = () => {
  const [contentWidth, setContentWidth] = useState(0);
  const [, notifyResize] = useState({});
  const containerRef = useRef<HTMLDivElement>(null);
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const navigationItems = Array.from(container.children) as HTMLElement[];

    const calculatedTotalWidth = navigationItems.reduce((sum, item) => {
      const range = document.createRange();
      range.selectNodeContents(item);
      const { width } = range.getBoundingClientRect();
      return sum + width;
      // we assume 100 is the initial width of the container to give it some space
    }, 100);

    setContentWidth(calculatedTotalWidth);
  }, [pathname]);

  // Check if the screen is mobile or the content is wider than the screen
  // to determine if the container is too narrow for its content
  const matchMobile = useMediaQuery("(max-width: 764px)");
  const matchContent = window.matchMedia(`(max-width: ${contentWidth}px)`);

  useEffect(() => {
    const handleResize = () => {
      notifyResize({});
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return {
    containerRef,
    isNarrow: matchMobile || matchContent.matches,
    contentWidth
  };
};

export default useIsNarrowContainer;
